/**
 * Canonical project source/entity kinds shared by lineage, source selection, and mentions.
 */
export const SOURCE_TYPES = [
  "document",
  "assumption",
  "hypothesis",
  "experiment",
  "learning",
  "insight",
] as const;

export type SourceType = (typeof SOURCE_TYPES)[number];

/**
 * Citation kinds accepted from conversation events and persisted assistant metadata.
 * Keep this closed for picker/mentions/lineage by using {@link SOURCE_TYPES} there instead.
 */
export const CITED_SOURCE_TYPES = [...SOURCE_TYPES, "mcpResult"] as const;

export type CitedSourceType = (typeof CITED_SOURCE_TYPES)[number];

export function isCitedSourceType(value: string): value is CitedSourceType {
  return (CITED_SOURCE_TYPES as readonly string[]).includes(value);
}